module.exports = __webpack_public_path__ + "img/scene_share_icon.ab842efb.png";